import { RolesWithProduct } from '@customTypes/api/Commons';
import { TermsType } from '@pages/UserGuide/Detail/constants/general';
import { PRODUCT_CODENAME_BY_PRODUCT_ID } from '@src/constants';

/**
 * intended to map which type-of-terms the application need to process for respective logged-in user role
 */
export const getTermsTypeToProcess = (
  rolesProduct: RolesWithProduct,
): TermsType[] => {
  const productCodeName = PRODUCT_CODENAME_BY_PRODUCT_ID[rolesProduct];

  switch (rolesProduct) {
    case RolesWithProduct['SPV.2W']:
    case RolesWithProduct['SPV.4W']:
    case RolesWithProduct['SPV.PBF']:
      return [
        TermsType.General,
        TermsType.SPV,
        TermsType[productCodeName as TermsType],
      ];
    case RolesWithProduct.BM:
      return [
        TermsType.General,
        TermsType['2W'],
        TermsType['4W'],
        TermsType.PBF,
        TermsType.BM,
      ];
    case RolesWithProduct.ABPM:
      return [
        TermsType.General,
        TermsType['2W'],
        TermsType['4W'],
        TermsType.PBF,
        TermsType.BM,
        TermsType.ABPM,
      ];
    case RolesWithProduct.AM:
      return [
        TermsType.General,
        TermsType['2W'],
        TermsType['4W'],
        TermsType.PBF,
        TermsType.BM,
        TermsType.AM,
      ];
    default:
      return [];
  }
};
